var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFan2 = function SvgFan2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 13
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fan2_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4705",
    transform: "translate(17 -480.904)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1066",
    width: 30,
    height: 13,
    rx: 3,
    transform: "translate(-17 480.904)",
    opacity: 0.8,
    fill: "url(#Fan2_svg__a)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-13 489.904)",
    fontSize: 7,
    fontFamily: "Roboto-Bold,Roboto",
    fontWeight: 700,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FAN")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4650"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Intersection 99",
    d: "M3.052 491.268l.275-1.364 3.362-2.616a3.991 3.991 0 00.8-.764 1.108 1.108 0 00.22-.644.633.633 0 00-.241-.523 1.1 1.1 0 00-.687-.189 1.622 1.622 0 00-.776.2 2.05 2.05 0 00-.654.572l-1.453-.957a3.229 3.229 0 011.315-1.142 4.2 4.2 0 011.9-.424 3.7 3.7 0 011.469.275 2.375 2.375 0 011.007.764 1.794 1.794 0 01.36 1.095 2.457 2.457 0 01-.4 1.353 5.844 5.844 0 01-1.4 1.386l-1.622 1.254h2.871l-.351 1.724z",
    fill: "#fff"
  })))));
};
export default SvgFan2;